import { forwardRef } from "react";
import { FaSearch } from "react-icons/fa";
import "./index.scss";

export interface SearchInputProps {
  value: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  onChangeText: (value: string) => void;
}

export const SearchInput = ({
  value,
  onChangeText,
  placeholder = "Pesquisar",
  disabled = false,
  className = "",
}: SearchInputProps) => {
  return (
    <div className={`search-container ${className}`}>
      <FaSearch className="icon-search" />
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        onChange={(e) => onChangeText(e.target.value)}
      />
    </div>
  );
};
